import { API_KEY } from "./gameConfig"

export const fetchTick = async (token: string): Promise<void> => {
  await fetch("/api/tick", {
    headers: {
      "x-gatsby-app-key": API_KEY || "",
      "Content-Type": "application/json",
    },
    method: "post",
    body: JSON.stringify({
      token,
    }),
  })
}
